// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.MassMessage = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MassMessage = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var MassMessage = _exports.MassMessage = function MassMessage(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.3326 2.01458C16.8442 1.78041 16.2776 1.84377 15.8567 2.18293L14.9966 2.86958C13.7825 3.84125 12.2575 4.37623 10.7033 4.37623H6.24919C3.83669 4.37623 1.875 6.33875 1.875 8.75042C1.875 11.0238 3.62332 12.8754 5.84249 13.0838L7.73 16.8587C8.12083 17.6404 8.90674 18.1254 9.78007 18.1254H10.8325C11.0167 18.1254 11.1909 18.0446 11.3092 17.9046C11.4275 17.7646 11.4792 17.5788 11.4492 17.3979L10.7375 13.1262C12.28 13.1346 13.7908 13.6671 14.9958 14.6313L15.8542 15.3179C16.1092 15.5212 16.415 15.6254 16.7241 15.6254C16.93 15.6254 17.1375 15.5796 17.3316 15.4854C17.82 15.2512 18.1234 14.7688 18.1234 14.2271V3.27292C18.1242 2.73209 17.8209 2.24958 17.3326 2.01458ZM3.12419 8.75042C3.12419 7.02792 4.52587 5.62623 6.24837 5.62623H10.7025C11.3817 5.62623 12.055 5.53874 12.7075 5.37207V12.1288C12.055 11.9621 11.3808 11.8746 10.7025 11.8746H6.24837C4.52587 11.8746 3.12419 10.4729 3.12419 8.75042ZM9.77915 16.8754C9.38165 16.8754 9.02505 16.6546 8.84755 16.2996L7.26003 13.1246H9.4692L10.0942 16.8754H9.77915ZM16.8742 14.2271C16.8742 14.2879 16.8467 14.3329 16.7909 14.3596C16.7359 14.3854 16.6817 14.3804 16.635 14.3421L15.7767 13.6554C15.2192 13.2096 14.6059 12.8438 13.9567 12.5604V4.9404C14.605 4.65707 15.2184 4.29124 15.7759 3.84624L16.6358 3.15873C16.6825 3.12123 16.7342 3.11457 16.7909 3.14124C16.8284 3.15957 16.8742 3.19707 16.8742 3.27373V14.2271Z",
      fill: "currentColor"
    }));
  };
});
